module.exports = __webpack_public_path__ + "img/octopus-energy_120X35.b9250f26.png";